module.exports = __webpack_public_path__ + "img/img3.f4bee8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/saasIntroduction/img3.png
// module id = 7Nrz
// module chunks = 171